import { Component, OnInit, OnDestroy } from '@angular/core';
import axios from 'axios';
import { HttpClient } from '@angular/common/http';
import { AngularFireStorage } from '@angular/fire/storage';
import { finalize } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { Authenticationservice } from '../../services/authentication.service';

@Component({
  selector: 'app-news-edit',
  templateUrl: './news-edit.component.html',
  styleUrls: ['./news-edit.component.css']
})
export class NewsEditComponent {
  constructor(private http: HttpClient, private storage: AngularFireStorage, private auth: Authenticationservice, private spinner: NgxSpinnerService) {
    let userdata;
    userdata = this.auth.Authention();
    let zone = userdata.zonedata;

    console.log('userdata: ', userdata);
    if ( userdata.userlevel == '12' || userdata.userlevel == '15') {
      this.editer = true
    } else this.editer = false;

  }
  editer: boolean;

  ngOnInit() {
    this.Load_slide();
  }

  isUploading = false;
  data_insert = { name: '', status: 1, like_pic: '' };
  data_slide = [];
  data_slide_a = [];

  Load_slide() {
    let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[dbCPS].[dbo].[Slide_pic]&w=1=1';
    axios.get(url).then(res => {
      let data = res.data.sort().reverse();
      if (data.length >= 1) {
        data = data.map(item => {
          return { ...item, modify: false };
        });
        this.data_slide = data.filter(el => el.status == 1);
        this.data_slide_a = data;
        console.log('data_slide: ', data);
      }
    }).catch(err => {
      throw (err)
    });
  }

  Change_val() {
    this.data_slide = [];
    let data = this.data_slide_a;
    this.data_slide = data.filter(el => el.status == 1);
    //console.log('data_slide2: ', data);
  }

  maxSize = 10 * 1024 * 1024; // 10 MB (adjust as needed)
  onFileSelected(event: any) {
    let dataI = this.data_insert
    var files = event.target.files[0];
    console.log(files);
    if (files.type.slice(0, 5) != 'image') {
      alert('กรุณาเลือกไฟล์ที่เป็น รูปภาพเท่านั้น');
      dataI.like_pic = '';
    }
    else if (files.size > this.maxSize) {
      alert('ไฟล์ที่จะอัพโหลด ขนาดไฟล์ต้องไม่เกิน 10 MB');
      dataI.like_pic = '';
    }
    else {
      const file = files[0]; // get single file      
      const Date_dt = new Date();
      const timestamp = Date_dt.getTime();
      //console.log('timestamp:', timestamp);
      const path = `brr_smartfarm/Slide_pic/Slp_${timestamp}`;
      const ref = this.storage.ref(path);
      const task = this.storage.upload(path, files);
      // เริ่มอัพโหลด ให้กำหนด isUploading เป็น true
      this.isUploading = true;

      this.storage
        .upload(path, file)
        .percentageChanges();
      task
        .snapshotChanges()
        .pipe(
          finalize(() => {
            ref
              .getDownloadURL()
              .toPromise()
              .then((url) => {
                //console.log('url:', url);
                let newUrl = url.split('&token')[0];
                //console.log('newUrl:', newUrl);
                this.data_insert.like_pic = newUrl;

                // this.firestore.collection('photos').doc(this.truckq).set(photo);
                // เมื่ออัพโหลดเสร็จสิ้นหรือเกิดข้อผิดพลาด ให้กำหนด isUploading เป็น false
                this.isUploading = false;
              });
          })
        ).subscribe();
    }
  }

  THtoLocalstring(date: string) {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZone: 'UTC'
    };
    return date1.toLocaleString('th-TH', options);
  }

  insert_to() {
    let data = this.data_insert;
    //insert_Slide_pic
    //let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/insert_t_c_v?t=[CPS6263].[dbo].[Slide_pic]&c=[name],[doc],[like_pic],[status]&v='${data.name}','','${data.like_pic}','${data.status}'`;
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/insert_Slide_pic?[name]=${data.name}&[doc]=&[like_pic]=${data.like_pic}&[status]=${data.status}`;

    console.log('test_url_insert:', url);
    if (confirm("ต้องการบันทึกข้อมูล หรือไม่")) {
      axios.get(url).then(res => {
        if (res.data.rowsAffected[0] >= 1) {
          this.Load_slide();
          alert("บันทึกข้อมูลสำเร็จ ");
          setTimeout(() => {
            this.data_insert = { name: '', status: 1, like_pic: '' };
          }, 100);
        }
      }).catch(err => { throw (err) })
    }
  }

  update_t() {
    let data = this.data_slide_a.filter(el => el.modify == true);
    console.log(data);
    let x = 0, y = 0;
    if (data.length > 0) {
      if (confirm('ต้องการบันทึกข้อมูล | จำนวน ' + data.length + ' รายการ หรือไม่?')) {
        for (let i = 0; i < data.length; i++) {
          let ar0 = data[i];
          let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_t_s_w?t=[dbCPS].[dbo].[Slide_pic]&s=[status]=${ar0.status}&w=[id]=${ar0.id}`
          axios.post(url).then(res => {
            let data = res.data;
            if (data.rowsAffected[0] == 1) y++
            else x++
          }).catch(err => { console.log(err) })
          //console.log('url', i, ';', url)        
        }
        this.Load_slide();
      }
    }
    else alert("ยังไม่มีการแก้ไขข้อมูล");

  }

}
